import { css } from '@emotion/react'

// https://github.com/machal/blanka-html

export const blankaCSS = css`
  /**
    * Blanka.css: Setting basic document typography
    ============================================
    - document minimal paddings
    - block elements with bottom margins only
    - same left margins for ul/ol, dd, blockquote
    */

  /**
    * Document minimal paddings
    */

  body {
    /* padding: 1.5rem; */
    padding: 0;
  }

  /**
    * Block elements with bottom margins only
    ---------------------------------------
    */

  p,
  ul,
  ol,
  dl,
  table,
  blockquote,
  pre,
  figure,
  hr {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    /* margin-bottom: 1rem; */
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    /* margin-bottom: 0.5rem; */
    margin-bottom: 0;
  }

  ul ul,
  ul ol,
  ol ul,
  ol ol {
    margin-bottom: 0;
  }

  /*
    Same left margins for ul/ol, dd, blockquote
    -------------------------------------------
    */

  ul,
  ol,
  dd {
    /* padding-left: 1.75rem; */
    padding-left: 0;
  }

  dd {
    margin-left: 0;
  }

  /*
    Blockquote
    ----------
    */

  blockquote {
    border: 0;
    padding-left: 1.75rem;
    margin-left: 0;
    font-style: italic;
  }

  /*
    Figure/Figcaption
    -----------------
    */

  figure {
    margin-left: 0;
    margin-right: 0;
  }

  figure > table,
  figure > img,
  figure > picture {
    margin-bottom: 0;
  }

  /*
    Etc.
    ----
    */

  fieldset {
    border: 0;
  }

  legend {
    padding: 0 0.5rem;
  }

  hr {
    border-style: solid;
    opacity: 0.25;
  }
`
